import { render } from "./practicalTrainingTable.vue?vue&type=template&id=e966ce9e"
import script from "./practicalTrainingTable.vue?vue&type=script&lang=js"
export * from "./practicalTrainingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__